/* Is the line up, and how do we survive it going down mid-sentence? */

const listeners = new Set();
let state = { online: typeof navigator === "undefined" || navigator.onLine !== false, dropped: false };

const emit = () => listeners.forEach((fn) => fn(state));

export const connection = () => state;

export const setDropped = (dropped) => {
  state = { ...state, dropped };
  emit();
};

export const onConnection = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

if (typeof window !== "undefined") {
  window.addEventListener("online", () => { state = { ...state, online: true }; emit(); });
  window.addEventListener("offline", () => { state = { ...state, online: false }; emit(); });
}

// a lost packet is not a lost thought: no response at all (or a 502/503/504) is worth another try
export const isNetworkError = (e) => {
  const code = e?.response?.status;
  if (!e?.response) return true;
  return [502, 503, 504].includes(code) && e?.response?.data?.detail === "offline";
};

export const withRetry = async (fn, tries = 3) => {
  let last;
  for (let i = 0; i < tries; i++) {
    try {
      const r = await fn();
      if (state.dropped) setDropped(false);
      return r;
    } catch (e) {
      last = e;
      if (!isNetworkError(e)) throw e;
      setDropped(true);
      if (i < tries - 1) await new Promise((res) => setTimeout(res, 800 * (i + 1)));
    }
  }
  throw last;
};
